import React, { Fragment, useEffect, useState} from 'react'
import Asegurado from './Asegurado'
import Conductor from './Conductor'
import Contratante from './Contratante'
import DatosSiniestro from './DatosSiniestro'
import { Auth } from 'recupero-comunes'
 
const DetallesCaso = () => {

  const { roles } = Auth.currentUser()
  const [permiteEditarPersona, setPermiteEditarPersona]=useState(false)

  useEffect(() => {
    const tieneRol = roles?.some(r => r.rol === "70ACTINVCIA") || false;
    setPermiteEditarPersona(tieneRol);
  }, [roles]);

  return (
    <>
      <DatosSiniestro />
      <Contratante permiteEditarPersona={permiteEditarPersona}/>
      <Asegurado permiteEditarPersona={permiteEditarPersona}/>
      <Conductor permiteEditarPersona={permiteEditarPersona}/>
    </>
  )
}
export default DetallesCaso